import { useMemo } from 'react';

import { CicloDoSeletor } from 'components/ui/seletor-de-ciclo';
import { useAuth } from 'context/AuthContext';
import { useCicloDaTela } from 'hooks/useCicloDaTela';

import { PRIMEIRO_CICLO_DO_CATALOGO, ULTIMO_CICLO_DO_CATALOGO } from '../catalogo-modelo';

export type CicloComInicio = CicloDoSeletor & { date_start: number };

/**
 * Ciclos oferecidos pela vitrine e pela página da experiência escolhida (as duas montam a mesma
 * lista, e o jogador transita entre elas). O teto é o da vitrine; `cycle-ceiling.spec.ts` o prende.
 */
export function ciclosDoCatalogo(realCycle: CicloComInicio[] | undefined): CicloComInicio[] {
  return (realCycle ?? []).filter(item => item.date_start >= PRIMEIRO_CICLO_DO_CATALOGO && item.date_start <= ULTIMO_CICLO_DO_CATALOGO);
}

/**
 * Ciclo da página: é o ciclo do app (CIC-10, CIC-11). Trocar aqui troca o do app. Quando o ciclo do app não
 * tem catálogo (o 2S2026, aberto, por exemplo), a página mostra o último ciclo que tem, em vez do aviso de CIC-12:
 * pedido da homologação (Cassia). O ciclo do app não muda sozinho. A regra é a de `cicloExibido`, a mesma de
 * Destaques e do Extrato de premiação (CIC-16).
 */
export function useCicloDoCatalogo() {
  const { realCycle } = useAuth();
  const ciclos = useMemo(() => ciclosDoCatalogo(realCycle as CicloComInicio[] | undefined), [realCycle]);
  const { cicloExibido: ciclo, trocar } = useCicloDaTela(ciclos);

  return { ciclos, cicloId: ciclo?._id, ciclo, trocarCiclo: trocar };
}
